import { constants } from "@newsela/angelou";

const { colors } = constants;

export const resultsLabelCss = {
  bottom: "-100%",
  color: colors.ui.neutral[700],
  fontWeight: "normal",
  height: "100%",
  left: "4px",
  position: "absolute",
};

export const chosenOptionResultsLabelCss = {
  ...resultsLabelCss,
  fontWeight: "bold",
};

export const noVotesResultsLabelCss = {
  ...resultsLabelCss,
  color: colors.ui.neutral[400],
};
